// extracted by mini-css-extract-plugin
module.exports = {"textarea":"dece2e673c--textarea--p58Ff","counter":"dece2e673c--counter--EYsRq"};